import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "*",
    redirect: "/login",
  },
  {
    path: "/fbDataDeletionInstructions",
    name: "fbDataDeletionInstructions",
    component: () =>
      import(
        /* webpackChunkName: "fbDataDeletionInstructions" */ "../views/FbDataDeletionInstructions.vue"
      ), // lazy rendering    
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/privacyPolicy",
    name: "privacyPolicy",
    component: () =>
      import(
        /* webpackChunkName: "privacyPolicy" */ "../views/PrivacyPolicy.vue"
      ), // lazy rendering    
    meta: {
      authRequired: false,
    },
  },
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/settingsColors",
    name: "settingsColors",
    component: () =>
      import(
        /* webpackChunkName: "settingsColors" */ "../views/superAdmin/SettingsColors.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenu") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsUserRights",
    name: "settingsUserRights",
    component: () =>
      import(
        /* webpackChunkName: "settingsUserRights" */ "../views/superAdmin/SettingsUserRights.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenu") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsDelivery",
    name: "settingsDelivery",
    component: () =>
      import(
        /* webpackChunkName: "settingsDelivery" */ "../views/superAdmin/SettingsDelivery.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenu") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPromoCodes",
    name: "settingsPromoCodes",
    component: () =>
      import(
        /* webpackChunkName: "settingsPromoCodes" */ "../views/superAdmin/SettingsPromoCodes.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenu") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsImageTemplate/:subPath",
    name: "settingsImageTemplate",
    component: () =>
      import(
        /* webpackChunkName: "settingsImageTemplate" */ "../views/superAdmin/SettingsImageTemplate.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuModulePhotoGift" ||
        from.name == "settingsPhotoGift"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsImageSize",
    name: "settingsImageSize",
    component: () =>
      import(
        /* webpackChunkName: "settingsImageSize" */ "../views/superAdmin/SettingsImageSize.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenuModulePhotoOrder") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPhotoOrderBasic",
    name: "settingsPhotoOrderBasic",
    component: () =>
      import(
        /* webpackChunkName: "settingsPhotoOrderBasic" */ "../views/superAdmin/SettingsPhotoOrderBasic.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuModulePhotoOrder" ||
        from.name == "home"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPhotoGiftBasic",
    name: "settingsPhotoGiftBasic",
    component: () =>
      import(
        /* webpackChunkName: "settingsPhotoGiftBasic" */ "../views/superAdmin/SettingsPhotoGiftBasic.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuModulePhotoGift" ||
        from.name == "home"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsUserSettingsBasic",
    name: "settingsUserSettingsBasic",
    component: () =>
      import(
        /* webpackChunkName: "settingsUserSettingsBasic" */ "../views/superAdmin/SettingsUserSettingsBasic.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuModuleUserSettings" ||
        from.name == "home"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsImageDiscounts",
    name: "settingsImageDiscounts",
    component: () =>
      import(
        /* webpackChunkName: "settingsImageDiscounts" */ "../views/superAdmin/SettingsImageDiscounts.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenuModulePhotoOrder") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPaperType",
    name: "settingsPaperType",
    component: () =>
      import(
        /* webpackChunkName: "settingsPaperType" */ "../views/superAdmin/SettingsPaperType.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenuModulePhotoOrder") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPhotoGiftCategory",
    name: "settingsPhotoGiftCategory",
    component: () =>
      import(
        /* webpackChunkName: "settingsPhotoGiftCategory" */ "../views/superAdmin/SettingsPhotoGiftCategory.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenuModulePhotoGift") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPhotoGiftSuperCategory",
    name: "settingsPhotoGiftSuperCategory",
    component: () =>
      import(
        /* webpackChunkName: "settingsPhotoGiftSuperCategory" */ "../views/superAdmin/SettingsPhotoGiftSuperCategory.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenuModulePhotoGift") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsPhotoGift",
    name: "settingsPhotoGift",
    component: () =>
      import(
        /* webpackChunkName: "settingsPhotoGift" */ "../views/superAdmin/SettingsPhotoGift.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenuModulePhotoGift") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsOther",
    name: "settingsOther",
    component: () =>
      import(
        /* webpackChunkName: "settingsOther" */ "../views/superAdmin/SettingsOther.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "settingsSubMenu") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userSettings",
    name: "userSettings",
    component: () =>
      import(
        /* webpackChunkName: "userSettings" */ "../views/user/UserSettings.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "home" ||
        from.name == "userCashier" ||
        from.name == "userCart"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/homeMenuAdminPackages",
    name: "homeMenuAdminPackages",
    component: () =>
      import(
        /* webpackChunkName: "homeMenuAdminPackages" */ "../views/homeMenu/HomeMenuAdminPackages.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home" || from.name == "homeMenuAdminArchive") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userCart",
    name: "userCart",
    component: () =>
      import(/* webpackChunkName: "userCart" */ "../views/user/UserCart.vue"), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "home" ||
        from.name == "userNewOrderBasic" ||
        from.name == "userNewPhotoGiftOrderFinalize" ||
        from.name == "userCashier"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userOrders",
    name: "userOrders",
    component: () =>
      import(
        /* webpackChunkName: "userOrders" */ "../views/user/UserOrders.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home" || from.name == "userCashier") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/homeMenuAdminArchive",
    name: "homeMenuAdminArchive",
    component: () =>
      import(
        /* webpackChunkName: "homeMenuAdminArchive" */ "../views/homeMenu/HomeMenuAdminArchive.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "homeMenuAdminPackages") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/stats",
    name: "stats",
    component: () =>
      import(
        /* webpackChunkName: "stats" */ "../views/superAdmin/Stats.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userImagePrices",
    name: "userImagePrices",
    component: () =>
      import(
        /* webpackChunkName: "userImagePrices" */ "../views/user/UserImagePrices.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userGiftPrices/:subPath",
    name: "userGiftPrices",
    component: () =>
      import(
        /* webpackChunkName: "userGiftPrices" */ "../views/user/UserGiftPrices.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userNewOrderBasic",
    name: "userNewOrderBasic",
    component: () =>
      import(
        /* webpackChunkName: "userNewOrderBasic" */ "../views/user/UserNewOrderBasic.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home" || from.name == "userCart") {
        next();
      } else {
        router.replace("/");
      }
    },
    beforeRouteLeave(to, from, next) {
      const answer = window.confirm('Do you really want to leave?')
      if (answer) {
        next()
      } else {
        next(false)
      }
    }
  },
  {
    path: "/userCashier",
    name: "userCashier",
    component: () =>
      import(
        /* webpackChunkName: "userCashier" */ "../views/user/UserCashier.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home" || from.name == "userCart") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsClient",
    name: "settingsClient",
    component: () =>
      import(
        /* webpackChunkName: "settingsClient" */ "../views/superAdmin/SettingsClient.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userNewPhotoGiftOrder/:subPath",
    name: "userNewPhotoGiftOrder",
    component: () =>
      import(
        /* webpackChunkName: "userNewPhotoGiftOrder" */ "../views/user/UserNewPhotoGiftOrder.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "home") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userNewPhotoGiftOrderDesign",
    name: "userNewPhotoGiftOrderDesign",
    component: () =>
      import(
        /* webpackChunkName: "userNewPhotoGiftOrderDesign" */ "../views/user/UserNewPhotoGiftOrderDesign.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "userNewPhotoGiftOrder") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/userNewPhotoGiftOrderFinalize",
    name: "userNewPhotoGiftOrderFinalize",
    component: () =>
      import(
        /* webpackChunkName: "userNewPhotoGiftOrderFinalize" */ "../views/user/UserNewPhotoGiftOrderFinalize.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (from.name == "userNewPhotoGiftOrderDesign") {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsSubMenu",
    name: "settingsSubMenu",
    component: () =>
      import(
        /* webpackChunkName: "settingsSubMenu" */ "../views/superAdmin/SettingsSubMenu.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "home" ||
        from.name == "settingsUserRights" ||
        from.name == "settingsOther" ||
        from.name == "settingsColors" ||
        from.name == "settingsDelivery" ||
        from.name == "settingsPromoCodes" ||
        from.name == "settingsImageTemplate" ||
        from.name == "settingsSubMenuModuleUserSettings" ||
        from.name == "settingsSubMenuImageDatabase" ||
        from.name == "settingsSubMenuModulePhotoOrder" ||
        from.name == "settingsSubMenuModulePhotoGift"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsSubMenuModulePhotoOrder",
    name: "settingsSubMenuModulePhotoOrder",
    component: () =>
      import(
        /* webpackChunkName: "settingsSubMenuModulePhotoOrder" */ "../views/superAdmin/SettingsSubMenuModulePhotoOrder.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenu" ||
        from.name == "settingsImageDiscounts" ||
        from.name == "settingsPaperType" ||
        from.name == "settingsPhotoOrderBasic" ||
        from.name == "settingsImageSize"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsSubMenuModulePhotoGift",
    name: "settingsSubMenuModulePhotoGift",
    component: () =>
      import(
        /* webpackChunkName: "settingsSubMenuModulePhotoGift" */ "../views/superAdmin/SettingsSubMenuModulePhotoGift.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenu" ||
        from.name == "settingsPhotoGiftBasic" ||
        from.name == "settingsPhotoGiftCategory" ||
        from.name == "settingsPhotoGiftSuperCategory" ||
        from.name == "settingsPhotoGift" ||
        from.name == "settingsImageTemplate"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsSubMenuModuleGiftCard",
    name: "settingsSubMenuModuleGiftCard",
    component: () =>
      import(
        /* webpackChunkName: "settingsSubMenuModuleGiftCard" */ "../views/superAdmin/SettingsSubMenuModuleGiftCard.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenu" || from.name == "settingsGiftCardActive"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsGiftCardActive",
    name: "settingsGiftCardActive",
    component: () =>
      import(
        /* webpackChunkName: "settingsGiftCardActive" */ "../views/superAdmin/SettingsGiftCardActive.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuModuleGiftCard"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsSubMenuModuleUserSettings",
    name: "settingsSubMenuModuleUserSettings",
    component: () =>
      import(
        /* webpackChunkName: "settingsSubMenuModuleUserSettings" */ "../views/superAdmin/SettingsSubMenuModuleUserSettings.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenu" ||
        from.name == "settingsUserSettingsBasic"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsImageDatabaseCategory/:type",
    name: "settingsImageDatabaseCategory",
    component: () =>
      import(
        /* webpackChunkName: "settingsImageDatabaseCategory" */ "../views/superAdmin/SettingsImageDatabaseCategory.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuImageDatabase"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsImageDatabase/:type",
    name: "settingsImageDatabase",
    component: () =>
      import(
        /* webpackChunkName: "settingsImageDatabase" */ "../views/superAdmin/SettingsImageDatabase.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenuImageDatabase"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/settingsSubMenuImageDatabase",
    name: "settingsSubMenuImageDatabase",
    component: () =>
      import(
        /* webpackChunkName: "settingsSubMenuImageDatabase" */ "../views/superAdmin/SettingsSubMenuImageDatabase.vue"
      ), // lazy rendering
    meta: {
      authRequired: true,
    },
    beforeEnter: (to, from, next) => {
      if (
        from.name == "settingsSubMenu" ||
        from.name == "settingsImageDatabaseCategory" ||
        from.name == "settingsImageDatabase"
      ) {
        next();
      } else {
        router.replace("/");
      }
    },
  },
  {
    path: "/login",
    name: "login",
    component: () =>
      import(/* webpackChunkName: "login" */ "../views/Login.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.authRequired)) {
    if (!store.state.storeAuth.isAuthenticated) {
      next({
        path: "/login",
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
